import * as React from "react";
import { styled } from "@mui/material/styles";
import Editor from "../editor/Editor";
import { inject } from "mobx-react";
import { observer } from "mobx-react";
import autobind from "autobind-decorator";
import NodeLayer, {
  questionTypes,
  narrativeSplitPoint,
} from "../editor/NodeLayer";
import { observable } from "mobx";
// import { RadioGroup, Radio } from 'react-radio-group';
// import CheckboxGroup from 'react-checkbox-group';
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Box,
} from "@mui/material";
import Icon from "@mdi/react";
import { Checkbox, CheckboxGroup } from "rsuite";
import ConnectionLayer from "../editor/ConnectionLayer";
import "rsuite/dist/rsuite.min.css";
import CustomLinkify from "../pages/questionnaire/components/CustomLinkify";
import { detectURLs, removeAnchorTags } from "../util/util";
import { mdiOpenInNew } from "@mdi/js";
import { HiExternalLink } from "react-icons/hi";

const StyledRadioGroup = styled("div")({
  margin: "12px",
  fontSize: "14",
  // color: 'rgb(120, 120, 120)',
});

const CheckboxContainer = styled("div")({
  margin: "12px",
  fontSize: "14",
  // color: 'rgb(120, 120, 120)',
});

const QuestionText = styled("p")({
  margin: "12px",
  fontSize: "32px",
  minHeight: "32px",
  color: "rgb(80, 80, 80)",
});

const TextInput = styled("input")({
  outline: "none",
  border: "1px solid rgb(220, 220, 220)",
  fontSize: "12px",
  padding: "8px",
  color: "rgb(80, 80, 80)",
  resize: "none",
  margin: "12px",
  width: "320px",

  "&:focus": {
    border: "1px solid rgb(180, 180, 180)",
  },
});

export class QuestionnaireChatState {
  @observable
  currentQuestionNode: NodeLayer;

  @observable
  questionsArray: NodeLayer[] = [];

  @observable
  currentQuestionPointer: number = 0;

  get isComplete(): boolean {
    return this.currentQuestionNode == null;
  }

  constructor(editor: Editor) {
    this.currentQuestionNode = editor.startLayer;
  }

  handlePrevious() {
    if (this.currentQuestionNode == null) {
      return;
    }
    if (this.currentQuestionPointer > 0 && this.questionsArray.length >= 1) {
      this.currentQuestionNode =
        this.questionsArray[--this.currentQuestionPointer];
    }
  }

  isConditionValid(conn: ConnectionLayer): boolean {
    if (conn.condition == "") {
      return true;
    }
    var conditionList = conn.condition.split(narrativeSplitPoint);

    var intersect = this.currentQuestionNode.answers.filter((it) =>
      conditionList.includes(it)
    );

    return intersect.length != 0;
  }

  handleNext() {
    if (this.currentQuestionNode == null) {
      return;
    }

    for (var conn of this.currentQuestionNode.outgoingConnections) {
      if (this.isConditionValid(conn)) {
        this.questionsArray[this.currentQuestionPointer] =
          this.currentQuestionNode;
        this.currentQuestionNode = conn.endNode;
        this.currentQuestionPointer++;
        return;
      }
    }

    this.currentQuestionNode = null;
  }
}

export type QuestionnaireEmbeddedRendererProps = {
  editor?: Editor;
  className?: string;
  state: QuestionnaireChatState;
  optioOnClick?: any;
  profilePic?: string;
};

export class RenderAnswerSelector extends React.Component<
  QuestionnaireEmbeddedRendererProps,
  { yesNoChoice: string; singleChoice: string; multipleChoice: string[] }
> {
  @observable
  private _stateProps = this.props.state;

  state = {
    yesNoChoice: "",
    singleChoice: "",
    multipleChoice: [],
  };

  @autobind
  singleOptionOnClick(choice: string) {
    this._stateProps.currentQuestionNode?.setAnswer(choice);
    // this.props.optioOnClick();
  }

  @autobind
  submitMultiChoice() {
    // console.log("submitMultiChoice 1")
    if (this.props.state.currentQuestionNode.answers.length > 0) {
      // console.log("submitMultiChoice 2")
      //this.props.optioOnClick();
    }
  }

  @autobind
  handleChange(event: React.ChangeEvent<HTMLInputElement>, stateKey: string) {
    const choiceValue = (event.target as HTMLInputElement).value;
    this.setState({
      ...this.state,
      [stateKey]: choiceValue,
    });
    this.singleOptionOnClick(choiceValue);
  }

  render() {
    if (this._stateProps.currentQuestionNode == null) {
      return null;
    }

    if (
      this._stateProps.currentQuestionNode.questionType == questionTypes.yesNo
    ) {
      return (
        <StyledRadioGroup key="answer-yesno">
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="answer-yesno"
              name="radio-buttons-group"
              value={this._stateProps.currentQuestionNode.answer}
              onChange={(ev) => this.handleChange(ev, "yesNoChoice")}
            >
              <FormControlLabel
                value="Yes"
                control={<Radio color="primary" />}
                label="Yes"
              />
              <FormControlLabel
                value="No"
                control={<Radio color="primary" />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
          {/* <div style={{ marginBottom: '12px' }}>
            
            <Button
              variant="contained"
              color={
                this._stateProps.currentQuestionNode.answer === 'Yes'
                  ? 'secondary'
                  : 'primary'
              }
              onClick={() => this.singleOptionOnClick('Yes')}
            >
              Yes
            </Button>
          </div> */}
          {/* <div>
            <Button
              variant="contained"
              color={
                this._stateProps.currentQuestionNode.answer === 'No'
                  ? 'secondary'
                  : 'primary'
              }
              onClick={() => this.singleOptionOnClick('No')}
            >
              No
            </Button>
          </div> */}
        </StyledRadioGroup>
      );
    }

    if (
      this._stateProps.currentQuestionNode.questionType ==
        questionTypes.singleChoice ||
      this._stateProps.currentQuestionNode.questionType == "Single Choice"
    ) {
      return (
        <StyledRadioGroup key="answer-singlechoice">
          <FormControl component="fieldset">
            {this._stateProps.currentQuestionNode.choices.map(
              (choice, index) => (
                <Box display="flex" alignItems="center">
                  <FormControlLabel
                    label={removeAnchorTags(choice)}
                    control={
                      <Radio
                        checked={
                          this._stateProps.currentQuestionNode.answer === choice
                        }
                        onChange={(ev) => this.handleChange(ev, "singleChoice")}
                        value={choice}
                        name="radio-buttons-group"
                        inputProps={{ title: `choice` }}
                        key={`radio-${index}`}
                      />
                    }
                  />
                  {detectURLs(choice)?.map((url: any) => {
                    const customUrl =
                      url.includes("https") || url.includes("http")
                        ? url
                        : `https://${url}`;
                    return (
                      <a
                        href={customUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {/* <Icon path={mdiOpenInNew} color="#fff" size={0.7} /> */}
                        <HiExternalLink
                          style={{
                            color: "#3f50b5",
                            fontSize: "1.2rem",
                          }}
                        />
                      </a>
                    );
                  })}
                </Box>
              )
            )}
            {/* <RadioGroup
              aria-label="answer-yesno"
              name="radio-buttons-group"
              value={this._stateProps.currentQuestionNode.answer}
              onChange={(ev) => this.handleChange(ev, "singleChoice")}
            >
              {this._stateProps.currentQuestionNode.choices.map(
                (choice, index) => (
                  <FormControlLabel
                    key={`radio-${index}`}
                    value={choice}
                    control={<Radio color="primary" />}
                    label={choice}
                  />
                )
              )}
            </RadioGroup> */}
          </FormControl>
        </StyledRadioGroup>
      );
    }

    if (
      this._stateProps.currentQuestionNode.questionType ==
        questionTypes.multiChoice ||
      this._stateProps.currentQuestionNode.questionType == "Multiple Choice"
    ) {
      let multiChoiceAns = [];
      return (
        <div>
          <CheckboxGroup
            // name="checkboxList"
            value={this._stateProps.currentQuestionNode?.answers}
            onChange={(value) => {
              // this.setState({ ...this.state, multipleChoice: [...value] });
            }}
          >
            {this._stateProps.currentQuestionNode.choices.map((choice) => {
              return (
                <Box display="flex" alignItems="center" gap="8px">
                  <Checkbox
                    key={choice}
                    value={choice}
                    onClick={() => {
                      if (
                        this._stateProps.currentQuestionNode.answers.find(
                          (ans) => ans === choice
                        )
                      ) {
                        multiChoiceAns =
                          this._stateProps.currentQuestionNode.answers.filter(
                            (ans) => ans !== choice
                          );
                      } else {
                        multiChoiceAns = [
                          ...this._stateProps.currentQuestionNode.answers,
                          choice,
                        ];
                      }
                      this._stateProps.currentQuestionNode.setAnswers(
                        multiChoiceAns
                      );
                    }}
                  >
                    {removeAnchorTags(choice)}
                  </Checkbox>
                  {detectURLs(choice)?.map((url: any) => {
                    const customUrl =
                      url.includes("https") || url.includes("http")
                        ? url
                        : `https://${url}`;
                    return (
                      <a
                        href={customUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <HiExternalLink
                          style={{
                            color: "#3f50b5",
                            fontSize: "1.2rem",
                          }}
                        />
                      </a>
                    );
                  })}
                </Box>
              );
            })}
          </CheckboxGroup>
        </div>

        // {/* <CheckboxContainer>
        //   {this._stateProps.currentQuestionNode.choices.map((choice, index) => (
        //     <div style={{ marginBottom: '12px' }} key={`check-${index}`}>
        //       <Button
        //         variant="contained"
        //         color={
        //           this._stateProps.currentQuestionNode.answers.indexOf(
        //             choice
        //           ) >= 0
        //             ? 'secondary'
        //             : 'primary'
        //         }
        //         onClick={() => {
        //           multiChoiceAns = this._stateProps.currentQuestionNode.answers;
        //           if (multiChoiceAns.find((ans) => ans == choice)) {
        //             multiChoiceAns[index] = '';
        //           } else {
        //             multiChoiceAns[index] = choice;
        //           }
        //           this._stateProps.currentQuestionNode.setAnswers(
        //             multiChoiceAns.filter((ans) => ans)
        //           );
        //         }}
        //       >
        //         {choice}
        //       </Button>
        //     </div>
        //   ))}
        //   <Button
        //     variant="contained"
        //     onClick={this.submitMultiChoice}
        //   >
        //     SUBMIT
        //     <ForwardIcon style={{ marginLeft: '5px' }} />
        //   </Button>
        // </CheckboxContainer> */}
      );
    }
  }
}

@observer
export default class QuestionnaireEmbeddedRenderer extends React.Component<QuestionnaireEmbeddedRendererProps> {
  @observable
  multiChoiceAns: Array<string>;

  getCurrentQuestionText(): string {
    var { state } = this.props;

    if (state.currentQuestionNode == null) {
      return "";
    }

    return state.currentQuestionNode.questionText;
  }

  render() {
    return (
      <Box width="100%" padding="10px 20px" display="flex" flexDirection="row">
        <Box color="#5B5D65" alignContent="center">
          <CustomLinkify str={this.getCurrentQuestionText()} />
        </Box>
      </Box>
    );
  }
}
